<script>
import Common from '../../../../components/common/Common';
export default {
        init: () => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        
        },
        methods:{
         camelize: Common.camelize,
         toUpperCase: Common.toUpperCase,
    }
}
</script>
